import React from "react";
import { Button } from "@material-ui/core";
import { ISaveButtonProps } from "./types";

export const SaveButton = ({
  templateId,
  submitTemplate,
  updateTemplate,
  canSubmit,
  isClean,
}: ISaveButtonProps) => {
  const isSaveDisabled = !canSubmit() || isClean();
  return (
    <Button
      onClick={!!!templateId ? submitTemplate : updateTemplate}
      style={{ marginTop: 10 }}
      variant="contained"
      color="primary"
      disabled={isSaveDisabled}
    >
      {!!!templateId ? "Submit" : "Update"}
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/features/admin/pages/template-editor/components/save-button/SaveButton.tsx